import { gql, TypedDocumentNode } from '@apollo/client';

import {
  BoundingBox,
  MapAssetsFilterInput,
  MapData,
  MapInput,
  TaskBoundingBoxInput,
} from '@atom/types/map';

export const BASE_BOUNDING_BOX = gql`
  fragment BaseBoundingBox on BoundingBox {
    xMin
    xMax
    yMin
    yMax
  }
`;

export const GET_TASK_BOUNDING_BOX: TypedDocumentNode<
  { taskBoundingBox: BoundingBox },
  { input: TaskBoundingBoxInput }
> = gql`
  query taskBoundingBox($input: TaskBoundingBoxInput!) {
    taskBoundingBox(input: $input) {
      ...BaseBoundingBox
    }
  }
  ${BASE_BOUNDING_BOX}
`;

export const GET_MAP_ASSETS_FILTER: TypedDocumentNode<
  { mapAssetsFilter: MapData },
  { input: MapAssetsFilterInput }
> = gql`
  query mapAssetsFilter($input: MapAssetsFilterInput!) {
    mapAssetsFilter(input: $input) {
      clusters {
        id
        location
        count
      }
      assets {
        id
        name
        location
        assetType
        markerId
        mainPhotoFileId
        updatedDate
      }
      assetsCount
    }
  }
`;

export const GET_MAP: TypedDocumentNode<{ map: MapData }, { input: MapInput }> =
  gql`
    query map($input: MapInput!) {
      map(input: $input) {
        clusters {
          id
          location
          count
        }
        assets {
          id
          name
          location
          assetType
          markerId
          mainPhotoFileId
          schemaId
          updatedDate
        }
        assetsCount
        workOrders {
          id
          name
          inventoryAssetName
          dueDate
          plannedStartDate
          location
          statusId
          isClosed
          taskCount
          assigneeCount
          assignees {
            id
            firstName
            lastName
            photoUrl
            email
          }
        }
        workOrdersCount
        users {
          id
          email
          firstName
          lastName
          isVerified
          isActive
          photoUrl
          location
          role
        }
        usersCount
      }
    }
  `;
